import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { Notification } from './notification.component';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  private _subject = new Subject<Notification>();

  constructor() { }

  getObservable(): Observable<Notification> {
    return this._subject.asObservable();
  }

  alert(type: string, message: string, technicalDetails: any) {
    this._subject.next(new Notification(type, message, technicalDetails));
  }
}
